<template>
  <modal
    v-slot="{ data }"
    name="confirmTime"
    modal-style="compact"
    :is-required="true"
    :display-header-title="false"
  >
    <confirm-fulfillment-time
      :is-timeslot-verification-required="data.isTimeslotVerificationRequired"
      :previous-selected-time="data.previousSelectedTime"
      :confirm-click-handler="data.confirmClickHandler"
    />
  </modal>
</template>


<script>
  import ConfirmFulfillmentTime from './confirm-fulfillment-time/index.vue';


  export default {
    name: 'ConfirmFulfillmentTimeModal',

    components: {
      ConfirmFulfillmentTime
    }
  };
</script>
